import { render } from "./createLoanclient.vue?vue&type=template&id=66b9842c&scoped=true"
import script from "./createLoanclient.vue?vue&type=script&lang=js"
export * from "./createLoanclient.vue?vue&type=script&lang=js"

import "./createLoanclient.vue?vue&type=style&index=0&id=66b9842c&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b9842c"]])

export default __exports__